(function () {
  function initHugelkultur(section) {
    if (section.dataset.hugelkulturReady === 'true') return;

    var image = section.querySelector('[data-hugelkultur-image]');
    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-hugelkultur-tab]'));
    if (!image || !tabs.length) return;

    function selectTab(selectedTab) {
      tabs.forEach(function (tab) {
        var isSelected = tab === selectedTab;
        tab.classList.toggle('is-active', isSelected);
        tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      });

      image.srcset = selectedTab.dataset.imageSrcset;
      image.src = selectedTab.dataset.imageSrc;
      image.alt = selectedTab.dataset.imageAlt;
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        selectTab(tab);
      });
    });

    section.dataset.hugelkulturReady = 'true';
  }

  function initAll() {
    document.querySelectorAll('[data-hugelkultur-section]').forEach(initHugelkultur);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
